import {Component, OnInit} from '@angular/core';
import {SessionService} from '../../services/session.service';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from '../../services/auth.service';
import {User} from '../../models/user.model';
import {DashboardComponent} from '../dashboard/dashboard.component';
import {ProjectWizardComponent} from '../project-wizard/project-wizard.component';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
export class RootComponent implements OnInit {

  user: User;
  childDashboard: DashboardComponent = null;
  childProjectWizard: ProjectWizardComponent = null;
  myIsNullOrUndefined = isNullOrUndefined;

  constructor(private router: Router, private cookieService: CookieService, private authService: AuthService) {
    if (this.cookieService.check('API_TOKEN')) {
      if (!SessionService.apiToken) {
        SessionService.apiToken = this.cookieService.get('API_TOKEN');
      }
      if (!SessionService.user) {
        this.authService.getUser().subscribe(value => {
          SessionService.user = value;
          this.user = value;
          if (this.childProjectWizard) {
            this.childProjectWizard.editingState = value.is_superuser;
            console.log(this.user.is_superuser);
          }
        });
      } else {
        this.user = SessionService.user;
        console.log(this.user);
      }
    } else {
      this.router.navigate(['/login'], {queryParams: {next: this.router.url}});
    }
  }

  ngOnInit() {
  }

  toggleEditing() {
    if (this.childProjectWizard) {
      this.childProjectWizard.editingState = !this.childProjectWizard.editingState;
    }
    console.log(this.childProjectWizard.editingState);
  }

  doLogout() {
    this.authService.doLogout().subscribe(value => {
    });
    this.cookieService.delete('API_TOKEN');
    this.router.navigate(['/login']);
  }

  onActivate(childObj) {
    console.log(this.childProjectWizard);
    if (this.router.url.includes('dashboard')) {
      this.childDashboard = childObj;
    } else {
      this.childProjectWizard = childObj;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/components/root/root.component.ts